import React from 'react';

export default function Volume({ fill = '#FFF', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Icon-Set-Filled" transform="translate(-209.000000, -573.000000)" fill={fill}>
                    <path
                        d="M228,578.101 L228,580.101 C230.282,580.564 232,582.581 232,585 C232,587.419 230.282,589.436 228,589.899 L228,591.899 C231.388,591.41 234,588.523 234,585 C234,581.477 231.388,578.59 228,578.101 L228,578.101 Z M209,581 L209,589 C209,590.104 209.896,591 211,591 L214,591 L214,579 L211,579 C209.896,579 209,579.896 209,581 L209,581 Z M223,573 L216,577.667 L216,592.333 L223,597 C224.104,597 225,596.104 225,595 L225,575 C225,573.896 224.104,573 223,573 L223,573 Z"
                        id="volume"></path>
                </g>
            </g>
        </svg>
    );
}

export const MuteIcon = ({ fill = '#FFF', ...rest }: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg fill={fill} width="16px" height="16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                clipRule="evenodd"
                d="m2 7.5v3c0 .8.6 1.5 1.4 1.5h2.3l3.2 2.8c.1.1.3.2.4.2s.2 0 .3-.1c.2-.1.4-.4.4-.7v-.9l-7.2-7.2c-.5.2-.8.8-.8 1.4zm8 2v-5.8c0-.3-.1-.5-.4-.7-.1 0-.2 0-.3 0s-.3 0-.4.2l-2.8 2.5-4.1-4.1-1 1 3.4 3.4 5.6 5.6 3.6 3.6 1-1z"
                fillRule="evenodd"
            />
        </svg>
    );
};
